module.exports = __webpack_public_path__ + "e0639b578d7896feff6c6a15f46b9428.svg";